export const DEFAULT_CUBOID_COLOR = 0xFDE047;
export const SELECTED_CUBOID_COLOR = 0xffffff;
